import { render } from "./loading-spinner.vue?vue&type=template&id=b7a58452&scoped=true"
import script from "./loading-spinner.vue?vue&type=script&lang=js"
export * from "./loading-spinner.vue?vue&type=script&lang=js"

import "./loading-spinner.vue?vue&type=style&index=0&id=b7a58452&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a58452"]])

export default __exports__